import { render, staticRenderFns } from "./RSVPDashboardList.vue?vue&type=template&id=78a584ce&scoped=true"
import script from "./RSVPDashboardList.vue?vue&type=script&lang=ts"
export * from "./RSVPDashboardList.vue?vue&type=script&lang=ts"
import style0 from "./RSVPDashboardList.vue?vue&type=style&index=0&id=78a584ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a584ce",
  null
  
)

export default component.exports